<template>
   <div class="news-work">
        <!-- <HeaderTop></HeaderTop> -->
        <!-- <Header :page="1"></Header> -->
        <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>通知公告</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="news-wrapper main flex-between">
            <div class="left-section">
                <!-- <div class="subtitle headlines-subtitle">
                    <h2>工作动态</h2>
                </div> -->
                <ul class="news-lists">
                    <li class="flex-align-between list-box" v-for="(li, index) in lists" :key="index" @click="getoDetail(li)" >
                        <img :src="li.cover" alt="" v-show="li.cover !== undefined">
                        <div class="article">
                            <h3 class="f16 wes">{{li.title}}</h3>
                            <p class="f12 wes-3">{{li.introduction}}</p>
                            <div class="summarys flex-align">
                                <span>查看详情</span>
                                <!-- <span>编辑：{{li.author}}</span>
                                <span>阅读量：{{li.time || 0}}</span> -->
                            </div>
                        </div>
                        <div class="time">
                            <div class="date">
                                <div class="day">{{handleTimeFour(li.updateTime)}}</div>
                                <div class="month">{{handleTimeTwos(li.updateTime)}}</div>
                                </div>
                              <!-- {{li.createTime}}   -->
                        </div>
                    </li>
                </ul>
               <div class="more-btn" @click="getlist()" v-show="showBtn">
                   查看更多
               </div>
               <div class="nothing" v-show="!showBtn" >
                   <hr><span>已无更多</span><hr>
               </div>
            </div>
           <!-- <focusBar></focusBar> -->
        </div>    
        <footer-view></footer-view>
        <!-- <scorllTop></scorllTop> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            lists:[],
            currentPage: 1,
            // perPage: 7,
            showBtn:true,
        }
    },
    watch: {
        '$route': function(to,from){
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
            this.showBtn = true;
        }
    },
     methods: {
        async getlist() {
            let params = {
                clazz:4,
                pageSize:6,
                pageNum:this.currentPage++,
                // isAsc:'desc',
            }
            let resData = await Api.Home.getNewsList(params);
            // resData.rows.forEach((item, index) => {
            //     if(item.image !== undefined) {
            //          item.urls = this.imageURL + item.image
            //      } else {
            //          item.urls = undefined;
            //      }
            // })
            if(resData.rows.length == 0) {
                this.showBtn = false;
            }
            this.lists = this.lists.concat(resData.rows);
            // console.log(resData.rows);
        },

        async getoDetail(item) {
            if(item.hasOwnProperty('url')) {
                window.open(item.url);
            } else {
                let msg = {id:item.dId,type:item.clazz}
                this.$router.push('/list/course/detail/'+item.dId ,msg)
            }
        }
    },
    mounted() {
        
        this.getlist();
    },
    destroyed() {
    }
    // methods: {
    //     goPage(url) {
    //         Common.goPage(url, this);
    //     }
    // }
}
</script>

<style lang="less" scoped>
     @import "./less/news_common.less";
     @import "./less/news_headlines.less";
</style>